'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function LVFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-19w4qag1p", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-19w4qag1p)" }, /* @__PURE__ */ React.createElement("path", { fill: "#c51918", d: "M0 14h32v10H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 8h32v6H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#c51918", d: "M0 0h32v10H0z" })))
  );
}

export { LVFlag };
//# sourceMappingURL=LV.mjs.map
